import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { ErrorBoundary } from './components/ErrorBoundary'
import { LoginGate } from './components/LoginGate'
import { PageScrollbar } from './components/PageScrollbar'
import { PullOverlay } from './components/PullOverlay'
import { ScrollAffordances } from './components/ScrollAffordances'
import { SettingsDrawer } from './components/SettingsDrawer'
import { TopBar } from './components/TopBar'
import { Analysis } from './pages/Analysis'
import { BulkSignup } from './pages/BulkSignup'
import { Compare } from './pages/Compare'
import { Correlate } from './pages/Correlate'
import { Home } from './pages/Home'
import { Lurker } from './pages/Lurker'
import { Profile } from './pages/Profile'
import { applyAccent, useSettings } from './store/settings'

export default function App() {
  const accent = useSettings((s) => s.accent)
  const [settingsOpen, setSettingsOpen] = useState(false)

  useEffect(() => {
    applyAccent(accent)
  }, [accent])

  return (
    <ErrorBoundary>
      <LoginGate>
        <div className="min-h-screen">
          <TopBar onOpenSettings={() => setSettingsOpen(true)} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/correlate" element={<Correlate />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/bulk" element={<BulkSignup />} />
            <Route path="/lurker" element={<Lurker />} />
            <Route path="/profile/:handle" element={<Profile />} />
            <Route path="/profile/:handle/:collection" element={<Profile />} />
          </Routes>
          <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
          <PullOverlay />
          <PageScrollbar />
          <ScrollAffordances />
        </div>
      </LoginGate>
    </ErrorBoundary>
  )
}
